import InsightsCancelFeedbackCard from 'components/InsightsCancelFeedbackCard/InsightsCancelFeedbackCard'

export default InsightsCancelFeedbackCard
